/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UsersService } from './services/users.service';
import { RolesService } from './services/roles.service';
import { AiChatService } from './services/ai-chat.service';
import { ApplicationsService } from './services/applications.service';
import { ExtractionsService } from './services/extractions.service';
import { InvoicesService } from './services/invoices.service';
import { EmailsService } from './services/emails.service';
import { OutgoingPaymentsService } from './services/outgoing-payments.service';
import { PcrService } from './services/pcr.service';
import { NotificationsService } from './services/notifications.service';
import { AdminService } from './services/admin.service';
import { LeadsService } from './services/leads.service';
import { OperationalTasksService } from './services/operational-tasks.service';
import { BankServiceConnectionsService } from './services/bank-service-connections.service';
import { TextMessageTemplatesService } from './services/text-message-templates.service';
import { ClientsService } from './services/clients.service';
import { CompanyFormsService } from './services/company-forms.service';
import { EinvoiceAddressLookupService } from './services/einvoice-address-lookup.service';
import { YtjService } from './services/ytj.service';
import { EndCustomersService } from './services/end-customers.service';
import { EndCustomerContactsService } from './services/end-customer-contacts.service';
import { DocumentsService } from './services/documents.service';
import { SignedDocumentsService } from './services/signed-documents.service';
import { ClientRepresentativesService } from './services/client-representatives.service';
import { CommentsService } from './services/comments.service';
import { ExportsService } from './services/exports.service';
import { ReportsService } from './services/reports.service';
import { FinancingHoldsService } from './services/financing-holds.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UsersService,
    RolesService,
    AiChatService,
    ApplicationsService,
    ExtractionsService,
    InvoicesService,
    EmailsService,
    OutgoingPaymentsService,
    PcrService,
    NotificationsService,
    AdminService,
    LeadsService,
    OperationalTasksService,
    BankServiceConnectionsService,
    TextMessageTemplatesService,
    ClientsService,
    CompanyFormsService,
    EinvoiceAddressLookupService,
    YtjService,
    EndCustomersService,
    EndCustomerContactsService,
    DocumentsService,
    SignedDocumentsService,
    ClientRepresentativesService,
    CommentsService,
    ExportsService,
    ReportsService,
    FinancingHoldsService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
